import React from "react";
import ContactForm from "../components/ContactForm";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileNav from "../components/MobileNav";

const ContactUs = () => {
  return (
    <div className="bg">
      <Header active="" active1="" active3="active" />
      <MobileNav />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default ContactUs;
